import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useModal } from '../../utils/useModal';
import { WrappedRepeatAiModal } from '../../RepeatAiModal';

export function useRepeatModal(aiId: string | null) {
  const { isPermitted } = useActionItem(aiId);

  const canRepeat = isPermitted(Operation.repeat);

  const { show: showRepeatAiModal } = useModal(WrappedRepeatAiModal, {
    aiId,
  });

  return [canRepeat, showRepeatAiModal] as const;
}
